import { useLazyQuery } from '@apollo/client';
import { CHECK_MEMBER_ACCESS_TO_GYM } from '@pass-frontend/features/facility-checkin/data-access';

export const useFindMemberAccess = () => {
  const [fetchaccess, { loading, data, error }] = useLazyQuery<{
    checkMemberAccessToGym: boolean;
  }>(CHECK_MEMBER_ACCESS_TO_GYM, {
    fetchPolicy: 'no-cache',
  });
  return {
    loading,
    error,
    hasAccess: data?.checkMemberAccessToGym,
    fetchaccess: (
      facilityId: string,
      authTags: any,
      product: any,
      serviceSector: any,
      sponsorId: any,
      isDependent: any,
      tierGroupId: any,
    ) => {
      fetchaccess({
        variables: {
          facilityId: facilityId,
          memberTags: authTags,
          product: product,
          serviceSector: serviceSector,
          sponsorId: sponsorId,
          isDependent: isDependent,
          tierGroupId: tierGroupId,
        },
      });
    },
  };
};
